import type { DynamicComboboxFilterOption } from "../types/filterOptions";

export const resolveOptionLabel = (options: readonly DynamicComboboxFilterOption[], id: string): string =>
    options.find((option) => option.id === id)?.label ?? id;

// Result chips read "Field Title: Value"
export const composeFieldChipLabel = (title: string | undefined, value: string): string =>
    title ? `${title}: ${value}` : value;
